module.exports = __webpack_public_path__ + "static/img/QuantData.55f53ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/QuantData.png
// module id = knzG
// module chunks = 3